import React, { useRef, useState } from 'react';
import { FileImage, Loader2, Paperclip, X } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Textarea } from '../../components/ui/Textarea';
import { useDemo } from '../../contexts/DemoContext';
import { complaintTypes } from '../../data/complaints';
export function ReportFraud() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const {
    addComplaint
  } = useDemo();
  const [type, setType] = useState(params.get('type') ?? '');
  const [form, setForm] = useState({
    caseNo: '',
    vehicle: '',
    name: '',
    mobile: '',
    description: ''
  });
  const [sms, setSms] = useState<string | null>(null);
  const [notice, setNotice] = useState<string | null>(null);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);
  const smsRef = useRef<HTMLInputElement>(null);
  const noticeRef = useRef<HTMLInputElement>(null);
  const set = (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm(f => ({
    ...f,
    [k]: e.target.value
  }));
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const next: Record<string, string> = {};
    if (!type) next.type = 'অভিযোগের ধরন নির্বাচন করুন';
    if (!form.name.trim()) next.name = 'আপনার নাম লিখুন';
    if (!/^(০১|01)[০-৯0-9]{9}$/.test(form.mobile.trim())) next.mobile = 'সঠিক ১১ অঙ্কের মোবাইল নম্বর দিন';
    if (form.description.trim().length < 15) next.description = 'অভিযোগের বিবরণ কমপক্ষে ১৫ অক্ষরের হতে হবে';
    setErrors(next);
    if (Object.keys(next).length) return;
    setLoading(true);
    setTimeout(() => {
      const c = addComplaint({
        type,
        caseNo: form.caseNo,
        vehicle: form.vehicle || '—',
        name: form.name,
        mobile: form.mobile,
        description: form.description,
        smsSender: sms ? 'অজানা প্রেরক' : '',
        smsText: sms ? 'নাগরিক কর্তৃক আপলোডকৃত SMS স্ক্রিনশট' : '',
        hasNoticeImage: !!notice
      });
      navigate(`/citizen/report/success?id=${c.id}`);
    }, 900);
  };
  const fillSample = () => {
    setType('সন্দেহজনক পেমেন্ট লিংক');
    setForm({
      caseNo: 'DMP/AI/2025/0614/0748',
      vehicle: 'ঢাকা মেট্রো-গ-২৩-৭১০৭',
      name: 'মোঃ মিলন মিয়া',
      mobile: '০১৮৩০০৯০৮১৯',
      description: 'অপরিচিত নম্বর থেকে SMS এসেছে, একটি লিংকে ক্লিক করে জরিমানা পরিশোধ করতে বলা হয়েছে।'
    });
    setSms('sms_screenshot.png');
    setErrors({});
  };
  const Upload = ({
    label,
    file,
    setFile,
    inputRef
  }: {
    label: string;
    file: string | null;
    setFile: (f: string | null) => void;
    inputRef: React.RefObject<HTMLInputElement>;
  }) => <div data-id="element-2134" data-mp="qrpmjmcffos9">
      <span className="mb-1.5 block font-medium" data-id="element-2135" data-mp="qpd4782rbceo">{label}</span>
      {file ? <div className="flex items-center gap-3 rounded-lg border border-[#16834A]/40 bg-[#E7F4EC]/50 p-3" data-id="element-2136" data-mp="csgitm5eqn56">
          <FileImage className="h-8 w-8 text-[#16834A]" data-id="element-2137" data-mp="hsugca9dueoy" />
          <span className="flex-1 truncate text-sm" data-id="element-2138" data-mp="3ubf1rlo9pplb">{file}</span>
          <button type="button" onClick={() => setFile(null)} aria-label="সরান" className="rounded p-1 hover:bg-white" data-id="element-2139" data-mp="3pb97ryuizr02"><X className="h-4 w-4" data-id="element-2140" data-mp="75ee3n9dqhiv" /></button>
        </div> : <button type="button" onClick={() => inputRef.current?.click()} className="flex w-full flex-col items-center rounded-lg border-2 border-dashed border-slate-300 p-5 text-sm text-slate-600 hover:border-[#1769AA] hover:bg-[#E8F1FA]/40" data-id="element-2141" data-mp="73jqu2amydbm">
          <Paperclip className="mb-1 h-5 w-5" data-id="element-2142" data-mp="c590bdi7mixl" /> ছবি নির্বাচন করুন (JPG, PNG)
        </button>}
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={e => setFile(e.target.files?.[0]?.name ?? null)} data-id="element-2143" data-mp="qtwupggbkmly" />
    </div>;
  return <div className="mx-auto max-w-3xl px-4 py-8" data-id="element-2144" data-mp="lwwqlb315txh">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-2145" data-mp="zvd35inkqenj">
        <div data-id="element-2146" data-mp="uvqtfj6yfgjh">
          <h1 className="text-2xl font-bold text-[#003B71]" data-id="element-2147" data-mp="uw0a2g640bci">সন্দেহজনক SMS বা নোটিশ রিপোর্ট করুন</h1>
          <p className="mt-1 text-sm text-slate-600" data-id="element-2148" data-mp="2pc8mxbs8gqe7">আপনার তথ্য গোপন রাখা হবে এবং শুধুমাত্র তদন্তের কাজে ব্যবহৃত হবে।</p>
        </div>
        <button type="button" onClick={fillSample} className="text-sm font-medium text-[#1769AA] hover:underline" data-id="element-2149" data-mp="2u8pekfyn5mw1">ডেমো: নমুনা তথ্য বসান</button>
      </div>

      <form onSubmit={submit} noValidate className="mt-6 space-y-6 rounded-xl border border-border bg-white p-6 md:p-8" data-id="element-2150" data-mp="3333qc8jyqfae">
        <fieldset data-id="element-2151" data-mp="26dwejs95bkjo">
          <legend className="mb-2 font-medium" data-id="element-2152" data-mp="26efksbpfokhv">অভিযোগের ধরন <span className="text-[#D93036]" data-id="element-2153" data-mp="2bb62t4kstq5x">*</span></legend>
          <div className="grid gap-2 sm:grid-cols-2" data-id="element-2154" data-mp="2bds970vydzmk">
            {complaintTypes.map(t => <label key={t} className={`flex cursor-pointer items-center gap-2.5 rounded-lg border-2 px-4 py-3 ${type === t ? 'border-[#003B71] bg-[#E8F1FA]/50' : 'border-border'}`} data-id="element-2155" data-mp="2ffdu99in5k7u">
                <input type="radio" name="type" className="h-4 w-4 accent-[#003B71]" checked={type === t} onChange={() => setType(t)} data-id="element-2156" data-mp="3qs6hq84efmi3" /> {t}
              </label>)}
          </div>
          {errors.type && <span className="mt-1 block text-sm text-[#D93036]" data-id="element-2157" data-mp="9pabq961w1zn">{errors.type}</span>}
        </fieldset>
        <div className="grid gap-4 sm:grid-cols-2" data-id="element-2158" data-mp="4rqx385fxn76">
          <label className="block" data-id="element-2159" data-mp="3w4v4okb92lsl"><span className="mb-1.5 block font-medium" data-id="element-2160" data-mp="3w4btrnk0oxo2">মামলা নম্বর (যদি থাকে)</span><Input value={form.caseNo} onChange={set('caseNo')} className="h-11 font-mono" placeholder="DMP/AI/..." data-id="element-2161" data-mp="3s4uq8zo5ialj" /></label>
          <label className="block" data-id="element-2162" data-mp="3n5rih7gsdq9v"><span className="mb-1.5 block font-medium" data-id="element-2163" data-mp="3n2vlblcrj5mh">গাড়ির নম্বর</span><Input value={form.vehicle} onChange={set('vehicle')} className="h-11" placeholder="ঢাকা মেট্রো-..." data-id="element-2164" data-mp="3i4u290fc76b0" /></label>
          <label className="block" data-id="element-2165" data-mp="3d7aoe1mjwvjl"><span className="mb-1.5 block font-medium" data-id="element-2166" data-mp="3d8vb552mja6w">নাম <span className="text-[#D93036]" data-id="element-2167" data-mp="395yz5x7lacbx">*</span></span><Input value={form.name} onChange={set('name')} className="h-11" data-id="element-2168" data-mp="397a1rtpate1g" />{errors.name && <span className="mt-1 block text-sm text-[#D93036]" data-id="element-2169" data-mp="1bew08kteyuuq">{errors.name}</span>}</label>
          <label className="block" data-id="element-2170" data-mp="17f592fzz6cpo"><span className="mb-1.5 block font-medium" data-id="element-2171" data-mp="17bptlc2e31nq">মোবাইল <span className="text-[#D93036]" data-id="element-2172" data-mp="30wazlo093iw9">*</span></span><Input value={form.mobile} onChange={set('mobile')} className="h-11" placeholder="০১XXXXXXXXX" inputMode="tel" data-id="element-2173" data-mp="30ugdw7h5nmr4" />{errors.mobile && <span className="mt-1 block text-sm text-[#D93036]" data-id="element-2174" data-mp="2rw4qeebl552w">{errors.mobile}</span>}</label>
        </div>
        <label className="block" data-id="element-2175" data-mp="2vwyfhb0rkpxd">
          <span className="mb-1.5 block font-medium" data-id="element-2176" data-mp="2vy9jnby4fzp0">অভিযোগের বিবরণ <span className="text-[#D93036]" data-id="element-2177" data-mp="3jnalggcg8clb">*</span></span>
          <Textarea rows={4} value={form.description} onChange={set('description')} placeholder="কখন, কোন নম্বর থেকে, কী বার্তা পেয়েছেন তা লিখুন" data-id="element-2178" data-mp="3jnu1tsmgasx8" />
          {errors.description && <span className="mt-1 block text-sm text-[#D93036]" data-id="element-2179" data-mp="3alb41mxiv6hu">{errors.description}</span>}
        </label>
        <div className="grid gap-4 sm:grid-cols-2" data-id="element-2180" data-mp="3fk4fzax5upfw">
          <Upload label="SMS স্ক্রিনশট আপলোড" file={sms} setFile={setSms} inputRef={smsRef} data-id="element-2181" data-mp="1z77a2gqxpics" />
          <Upload label="নোটিশের ছবি আপলোড" file={notice} setFile={setNotice} inputRef={noticeRef} data-id="element-2182" data-mp="246afi2attqla" />
        </div>
        <Button type="submit" className="h-12 w-full text-base" disabled={loading} data-id="element-2183" data-mp="1vp01v9vwo5sc">
          {loading ? <><Loader2 className="h-5 w-5 animate-spin" data-id="element-2184" data-mp="1rnya1e4biw0e" /> জমা দেওয়া হচ্ছে…</> : 'অভিযোগ জমা দিন'}
        </Button>
      </form>
    </div>;
}